import { CommunityChannelVisibilityEnumItem } from '@ps/api/types';

export const ChannelVisibility = CommunityChannelVisibilityEnumItem;
export type ChannelVisibility =
  (typeof ChannelVisibility)[keyof typeof ChannelVisibility];
